{
  "submit": "אישור",
  "first name": "שם פרטי",
  "last name": "שם משפחה",
  "email": "דואר אלקטרוני",
  "remail": "אישור דואר אלקטרוני",
  "phone number": "מספר טלפון",
  "please enter first name": "אנא הכנס שם פרטי",
  "please enter last name": "אנא הכנס שם משפחה",
  "the email is not in correct format": "אנא תקן את כתובת הדואר האלקטרוני",
  "the email are not match": "כתובות הדואר האלקטרוני שהזנת אינן תואמות",
  "please enter phone number in correct format": "אנא הכנס מספר טלפון חוקי",
  "some data is missing": "אנא מלא את כל הפרטים",
  "register": "הרשמה",
  "upload": "קמפיין",
  "payment": "תשלום",
  "csv file": "העלאת רשימת מספרים",
  "mp3 file": "העלאת הקלטה*",
  "csv explain": "יש להעלות את הקובץ בפורמט .csv או .xlsx העמודה של מספרי הטלפון היא חובה ",
  "sound file explain": "יש להעלות את הקובץ בפורמט .mp3 או .wav",
  "file name": "שם הקובץ",
  "csv file name": "שם קובץ רשימת מספרים",
  "audio file name": "שם קובץ הקלטה",
  "duration": "אורך הקלטה",
  "csvlegnth": "כמות עמודות בטבלה",
  "file": "שם הקובץ",
  "total payment": "סה\"כ תשלום",
  "receive feedback": "קבלת משוב",
  "full name": "שם מלא",
  "options": "אפשריות",
  "add new": "הוסף",
  "delete": "מחק",
  "addNumber": "הוספת רשומה ידנית",
  "please enter full name": "אנא הכנס שם מלא",
  "Send email for confirmation": "נשלח דואר אלקטרוני לאישור",
  "code": "קוד זמני לאישור",
  "wrong code": "הקוד לא תקין",
  "next": "הבא >>",
  "cant go step forward": "כדי להתקדם לשלב הבא אנא מלא את הטופס ולחץ הבא.",
  "total rows": "סה\"כ עמודות",
  "total duration": "סה\"כ שניות",
  "second rate": "תעריף לשנייה",
  "upload form empty": "אנא וודאו כי הוספתם רשימת שליחה, קובץ שמע ותאריך",
  "upload file": "העלאת קובץ",
  "add member by hand": " הוספת רשומות ידנית",
  "minutes rate": "תעריף לדקה",
  "total seconds explain": "",
  "rate explain": "תעריף משתנה אם רצוי משוב",
  "total payment explain": "עמודות*תעריף*דקות",
  "total minutes": "סה\"כ דקות",
  "date picker": "תאריך תחילת קמפיין*",
  "there is no code": "אנא הכנס קוד",
  "send_email_again": "שלח אימייל שנית",
  "we_send_the_code": "נשלח אימייל חוזר",
  "choose time": "בחר שעה",
  "your request is send": "הבקשה נשלחה!",
  "your requset can take time": "נא להמתין התהליך יכול לקחת כמה דקות",
  "your request is done!": "הפעולה הסתיימה!",
  "go to finish page": "סיום",
  "the_campaign_already_created": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "the_campaign_created": "הקמפיין נוצר בהצלחה",
  "missing_some_data": "חסר מידע",
  "some_inforimation_is_wrong": "חלק מהמידע לא תקין",
  "server_error": "בעיה אנא פנה אל שירות הלקוחות",
  "server_error_id_is_not_exitis": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "there_is_problems_with_files": "הקבצים שנשלחו לא בפורמט מתאים",
  "there_is_no_rows_in_csv": "נשלחה רשומת שליחה ריקה",
  "there_is_a_problem_in_csv_content": "חלק ממספרי רשימת השליחה אינה חוקיים",
  "there_is_problem_with_create_callerId": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "the_date_already_pass": "התאריך שנשלח כבר עבר",
  "the_date_is_unvalid": "התאריך שנשלח לא תקין",
  "the_time_already_pass": "השעה שנשלחה כבר עברה",
  "the_time_is_unvalid": "השעה שנשלחה לא תקינה",
  "error_to_get_avaliable_numbers": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "error_create_number": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "error_purchase": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "error_delete_number": "לצערנו הרב קרתה בעיה אנא התחל את התהליך מחדש",
  "error csv file": "אנא וודו כי הקובץ מכיל עד 10000 שורות",
  "error sound file": "אנא וודו כי גודל הקבוץ קטן מ 5.5MB",
  "the list is full": "הרשימה מלאה!",
  "error in list": "אנא וודו כי הרשימה מכילה עד 10000 שורות",
  "list error": "בעיה ברשימה!",
  "number is already in the list": "המספר שהוכנס כבר קים ברשימה",
  "somting_went_wrong": "בעיה,אנא פנה אל שירות הלקוחות או שתעשה את התהליך מחדש",
  "thank you for using our service": "תודה על השימוש בשירות. הקמפיין נוצר בהצלחה!",
  "in few minutes a mail will send to you with inforamtion about your campaign": "בעוד מספר דקות ישלח אלייך מייל עם חשבונית ופרטי הקמפיין.",
  "if you enjoy our service we have more good services": "לשירותים נוספים:",
  "success": "הצלחה",
  "more services": "שירותים",
  "switch credit card": "החלף כרטיס אשראי",
  "submit campaign": "שלח קמפיין",
  "please upload valid file": "הקובץ אינו תקין",
  "there is a problem please try again": "יש בעיה אנא נסו שנית"
}
